const features = [
  {
    icon: 'ri-book-open-line',
    title: '深度叙事',
    description: '超过15万字剧情文本，7条主线、15种结局，构建宏大的互动叙事宇宙。每一个选择都经过精心设计，确保故事的连贯性和深度。'
  },
  {
    icon: 'ri-user-heart-line',
    title: '角色羁绊',
    description: '与多位性格鲜明的角色建立羁绊，好感度系统将解锁隐藏对话和专属剧情，让你深入了解每个角色背后的故事。'
  },
  {
    icon: 'ri-stack-line',
    title: '多线分支',
    description: '非线性剧情结构，关键节点的选择将导向完全不同的故事走向。每一次重玩都是一次全新的叙事体验。'
  },
  {
    icon: 'ri-music-line',
    title: '原创配乐',
    description: '知名作曲家倾力打造，东方传统乐器与现代电子音乐完美融合，为每一个场景注入独特的情感色彩。'
  },
  {
    icon: 'ri-paint-brush-line',
    title: '精美美术',
    description: '融合中国水墨画风格与现代插画技法，超过200张精美CG插画，呈现极具辨识度的视觉风格。'
  },
  {
    icon: 'ri-file-search-line',
    title: '记忆碎片',
    description: '在剧情中收集隐藏的记忆碎片，拼凑出完整的世界观和隐藏真相。集齐全部碎片将解锁专属隐藏结局。'
  }
];

export default function GameplayFeatures() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-primary-600 text-sm font-medium tracking-wider mb-2">
            —— 玩法特色 ——
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            沉浸式体验
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-[550px] mx-auto">
            六大核心特色，为你打造无与伦比的互动叙事体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-background-100 rounded-lg p-6 transition-all duration-500 hover:-translate-y-1"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-4 transition-colors duration-500 group-hover:bg-accent-500 group-hover:text-background-50">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 font-bold mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}